// import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthActionButton from '../Button/AuthActionButton';
import AppStoreButton from '../Button/AppStoreButton';
import GooglePlayButton from '../Button/GooglePlayButton';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { languageState } from '../../recoil/language/languageAtom';
import i18n from '../../locales/i18n';
import { otpModalState } from '../../recoil/otp/otpModalAtom';
import * as Sentry from '@sentry/react';

const GlobalNav = ({ isOpen, onToggle, isLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [language, setLanguage] = useRecoilState(languageState);
  const setOtpModalState = useSetRecoilState(otpModalState);
  const MUBEAT_WEB_URL = process.env.REACT_APP_MUBEAT_WEB_URL;

  const clearSession = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('exp');
    Sentry.setUser(null);
  };

  // GNB 메뉴 is-active 처리를 위한 location 체크
  // TODO: App.jsx 라우터 path 변경 시 routeIsActive 인자 같이 수정 필요
  const routeIsActive = (path) => {
    return location.pathname === path;
  };

  const handleCloseButtonClick = () => {
    onToggle();
  };

  const changeSelectLanguage = (event) => {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);
    localStorage.setItem('selectedLanguage', newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  const handleLogin = () => {
    setOtpModalState(true);
  };

  const handleLogout = () => {
    clearSession();
    window.location.reload();
  };

  const handleAuth = () => {
    if (!isLogin) {
      handleLogin();
    } else {
      handleLogout();
    }
  };

  const goPurchaseHistory = () => {
    navigate('/purchase-history');
  };

  const goStarbeatHistory = () => {
    navigate('/starbeat-history');
  };

  return (
    <>
      <div className={`global-nav-wrapper ${isOpen && 'is-show'}`}>
        {/* 모바일에서만 노출 */}
        <div className='mb-show'>
          <div className={'mobile-gnb-top-wrapper'}>
            <div className='mobile-gnb-top-left-wrapper'>
              <div className='mobile-gnb-select-group'>
                <select
                  className={'default-input mobile-gnb-language-select'}
                  value={language}
                  onChange={changeSelectLanguage}
                >
                  <option value='en'>English</option>
                  <option value='ko'>한국어</option>
                  <option value='jp'>日本語</option>
                </select>
              </div>
              <div className='mobile-gnb-auth-group'>
                <AuthActionButton authState={isLogin} onClick={handleAuth} />
              </div>
            </div>
            <div className='mobile-gnb-top-right-wrapper'>
              <button
                type={'button'}
                className={'button-default mobile-gnb-close-button'}
                aria-label={'Close'}
                onClick={handleCloseButtonClick}
              >
                <i className={'icon icon-close-wh'} />
              </button>
            </div>
          </div>
        </div>

        <div className='global-combine-nav-group'>
          <div className='global-all-nav-group'>
            <ul className={'global-nav-group'}>
              {/* 현재는 is-active 고정, 추후 라우터 분리됐을 때 pathname별로 is-active binding */}
              <li className={'global-nav-list'}>
                <a href={MUBEAT_WEB_URL} className={'global-nav-link'}>
                  {t('mubeat').toUpperCase()}
                </a>
              </li>
              <li className={'global-nav-list'}>
                <a href={`${MUBEAT_WEB_URL}awards/list/`} className={'global-nav-link'}>
                  {t('awards').toUpperCase()}
                </a>
              </li>
              <li className={'global-nav-list'}>
                <a href={`${MUBEAT_WEB_URL}mubeat_plus/`} className={'global-nav-link'}>
                  {t('mubeat_plus').toUpperCase()}
                </a>
              </li>
              <li className={'global-nav-list'}>
                <a href={`${MUBEAT_WEB_URL}board/`} className={'global-nav-link'}>
                  {t('board').toUpperCase()}
                </a>
              </li>
              {/* 로그인에서만 노출 */}
              {isLogin ? (
                <li className={`global-nav-list ${routeIsActive('/starbeat-purchase') ? 'is-active' : ''}`}>
                  <a
                    href=''
                    className={'global-nav-link'}
                    onClick={() => {
                      navigate('/starbeat-purchase');
                    }}
                  >
                    {t('star_beat_purchase').toUpperCase()}
                  </a>
                </li>
              ) : null}
            </ul>
            {/* 모바일에서만 노출 */}
            <div className={'mb-show'}>
              {/* 로그인에서만 노출 */}
              {isLogin ? (
                <ul className={'mobile-global-nav-group'}>
                  <li className={'moblie-global-nav-list'}>
                    <a href='' className={'mobile-global-nav-link'} onClick={goPurchaseHistory}>
                      {t('purchase_history').toUpperCase()}
                    </a>
                  </li>
                  <li className={'moblie-global-nav-list'}>
                    <a href='' className={'mobile-global-nav-link'} onClick={goStarbeatHistory}>
                      {t('star_beat_history').toUpperCase()}
                    </a>
                  </li>
                </ul>
              ) : null}
              <div className={'mobile-app-button-wrapper'}>
                <div className='mobile-app-button-flex-wrapper'>
                  <AppStoreButton buttonType={'mono'} />
                  <GooglePlayButton buttonType={'mono'} />
                </div>
              </div>
            </div>
            {/* END 모바일에서만 노출 */}
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalNav;
